<template>
  <div>
    <Form ref="groupForm" :rules="ruleValidate" :model="groupInfo" :label-width="120">
      <FormItem label="活动名称" prop="spell_name">
        <Input
          style="width:300px"
          type="text"
          v-model="groupInfo.spell_name"
          placeholder="请输入名称，最多可添加28个字"
          :maxlength="28"
          clearable
        />
        <CharCount :max="28" :text="groupInfo.spell_name"></CharCount>
      </FormItem>
      <FormItem label="参团商品" prop="type_id">
        <Button
          type="default"
          v-if="!selectItem"
          icon="ios-add"
          @click="showSelectShopModal=true"
          :disabled="status==1"
        >选择商品</Button>
        <Button type="default" v-else @click="showSelectShopModal=true" :disabled="status==1">重新选择</Button>
        <span v-if="selectItem">
          <span>已选：「{{selectItem.type_name}}」{{selectItem.title||selectItem.name}}</span>
        </span>
      </FormItem>
      <FormItem label="生效时间" prop="start_time">
        <DatePicker
          type="datetime"
          v-model="groupInfo.start_time"
          placeholder="开始时间"
          :disabled="status==1"
          style="width: 200px"
        ></DatePicker>
        <span>-</span>
        <DatePicker
          type="datetime"
          v-model="groupInfo.end_time"
          placeholder="结束时间"
          style="width: 200px"
        ></DatePicker>
      </FormItem>
      <FormItem label="参团人数" prop="user_num">
        <InputNumber :max="20" :min="2" v-model="groupInfo.user_num" :disabled="status==1"></InputNumber>
        <span>人</span>
        <span class="tip ml8">拼团人数2-20人</span>
      </FormItem>
      <FormItem label="拼团有效期" prop="group_validtime">
        <InputNumber :max="72" :min="1" v-model="groupInfo.group_validtime" :disabled="status==1"></InputNumber>
        <span>小时</span>
        <span class="tip ml8">最大支持72小时</span>
      </FormItem>
      <FormItem label="活动库存" prop="stock">
        <div style="display:flex;">
          <InputNumber :min="1" v-model="groupInfo.stock" style="width:78px;flex-shrink: 0;"></InputNumber>
          <span>件</span>
          <a class="shop-edit" v-if="selectItem" @click="goToShopEdit">编辑商品库存</a>
          <span
            class="tip ml8"
          >活动库存单独管理，不与商品库存关联，为了不影响买家成团体验，建议活动库存为参团人数的倍数；买家支付成功后，将扣除活动库存，如拼图失败，退款后，将自动返还库存。</span>
        </div>
      </FormItem>
      <FormItem label="商品限购" prop="limited_buy" v-if="selectItem&&selectItem.type=='book'">
        <span>最多可购买</span>
        <InputNumber :min="1" v-model="groupInfo.limited_buy"></InputNumber>
        <span>件</span>
      </FormItem>
      <FormItem label="凑团设置">
        <div style="display:flex;">
          <Checkbox v-model="groupInfo.is_show_group" style="width:42px;flex-shrink: 0;">开启</Checkbox>
          <span class="tip">开启凑团后，对于未参团的买家，活动商品详情页会显示未成团的团列表，买家可以直接任选一个参团，提升成团率。</span>
        </div>
      </FormItem>
      <FormItem label="模拟成团">
        <div style="display:flex;">
          <Checkbox v-model="groupInfo.is_auto_succ" style="width:42px;flex-shrink: 0;">开启</Checkbox>
          <span
            class="tip"
          >开启模拟成团后，拼团有效期内人数未满的团，系统将会模拟“匿名买家”凑满人数，使该团成团。你只需要对已付款参团的真实买家发货。建议合理开启，以提高成团率。</span>
        </div>
      </FormItem>
      <FormItem label="开团限制">
        <div style="display:flex;">
          <Checkbox
            v-model="groupInfo.is_open_check_num"
            :disabled="status==1"
            style="width:142px;flex-shrink: 0;"
          >库存小于开团人数限制</Checkbox>
          <span
            class="tip"
          >开启后，当剩余库存小于成团人数时，买家在移动端依然可以开团，有可能导致超卖，需要卖家及时补充库存；反之，在移动端提示商品已售罄，有可能导致库存剩余。</span>
        </div>
        <div style="display:flex;">
          <Checkbox
            v-model="groupInfo.is_check_validtime"
            :disabled="status==1"
            style="width:142px;flex-shrink: 0;"
          >活动结束剩余时间小于拼团有效期</Checkbox>
          <span class="tip">开启后，当活动结束剩余时间小于拼团有效期时，买家在移动端依然可以开团，有可能导致拼团失败。反之，买家不可开团或参团。</span>
        </div>
      </FormItem>
      <FormItem label="优惠设置">
        <div style="display:flex;">
          <Checkbox v-model="groupInfo.is_use_coupon" style="width:42px;flex-shrink: 0;">开启</Checkbox>
          <span class="tip">开启后，可与优惠券/优惠码叠加使用</span>
        </div>
      </FormItem>
      <FormItem label="团长优惠">
        <div style="display:flex;">
          <Checkbox
            v-model="groupInfo.is_head_discount"
            :disabled="status==1"
            style="width:42px;flex-shrink: 0;"
          >开启</Checkbox>
          <span class="tip">开启团长(开团人)优惠后，团长将享受更优惠价格，有助于提高开团率和成团率。请注意：模拟成团的团长也能享受团长优惠，请谨慎设置，避免资金损失。</span>
        </div>
      </FormItem>
      <FormItem label="拼团价格" prop="spell_price" v-if="selectItem">
        <table class="table-price" cellspacing="0">
          <thead>
            <tr>
              <th>商品</th>
              <th>原价</th>
              <th style="width:150px;">拼团价</th>
              <th v-if="groupInfo.is_head_discount" style="width:150px;">团长优惠价</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{selectItem.title||selectItem.name}}</td>
              <td>¥{{selectItem.price/100}}</td>
              <td>
                <div>
                  <Input class="price" v-model="groupInfo.spell_price" :disabled="status==1">
                    <template slot="prefix">¥</template>
                  </Input>
                </div>
              </td>
              <td v-if="groupInfo.is_head_discount">
                <div>
                  <Input class="price" v-model="groupInfo.head_price" :disabled="status==1">
                    <template slot="prefix">¥</template>
                  </Input>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </FormItem>
      <FormItem style="text-align:center">
        <Button size="large" :to="{name:'GroupBookingManage'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          :loading="loading"
          @click="submitForm('groupForm')"
        >保存并返回</Button>
      </FormItem>
    </Form>
    <Modal class="grid-select" v-model="showSelectShopModal" title="选择商品" width="900px">
      <ShopSelect ref="shopSelect" :selectItems="selectItems"></ShopSelect>
      <template v-slot:footer>
        <Button type="default" @click="showSelectShopModal=false">取消</Button>
        <Button type="primary" @click="confirmSelectShop">确定</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
import ShopSelect from "@/components/GridSelect/ShopSelect.vue";
import { ShopType } from "@/utils/enums.js";
import autoMapper from "@/utils/automapper.js";
export default {
  name: "GroupBookingEdit",
  components: {
    ShopSelect
  },
  data() {
    let startTimeValidator = (rule, value, callback) => {
      if (this.groupInfo.start_time === "" || this.groupInfo.end_time === "") {
        callback(new Error("生效时间不能为空"));
      } else {
        callback();
      }
    };
    let priceValidator = (rule, value, callback) => {
      if (this.groupInfo.spell_price === "") {
        callback(new Error("拼团价不能为空"));
        return;
      }
      if (
        isNaN(this.groupInfo.spell_price) ||
        parseFloat(this.groupInfo.spell_price) < 0.01
      ) {
        callback(new Error("拼团价必须为数字且不得小于0.01"));
        return;
      }
      if (this.groupInfo.spell_price > this.selectItem.price / 100) {
        callback(new Error("拼团价不得大于商品原价"));
        return;
      }
      if (this.groupInfo.is_head_discount) {
        if (this.groupInfo.head_price === "") {
          callback(new Error("团长优惠价不能为空"));
          return;
        }
        if (
          isNaN(this.groupInfo.head_price) ||
          parseFloat(this.groupInfo.head_price) < 0.01
        ) {
          callback(new Error("团长优惠价必须为数字且不得小于0.01"));
          return;
        }
        if (this.groupInfo.head_price > this.groupInfo.spell_price) {
          callback(new Error("团长优惠价不得大于拼团价"));
          return;
        }
      }
      callback();
    };
    return {
      id: this.$route.query.id,
      groupInfo: {
        spell_name: "",
        start_time: "",
        end_time: "",
        user_num: 2,
        group_validtime: 1,
        stock: 1,
        limited_buy: 1,
        is_show_group: false,
        is_auto_succ: false,
        is_open_check_num: false,
        is_check_validtime: false,
        is_use_coupon: false,
        is_head_discount: false,
        spell_price: "",
        head_price: "",
        type_id: "",
        type: "",
        product_type: ""
      },
      ruleValidate: {
        type_id: [
          {
            required: true,
            type: "number",
            message: "参团商品不能为空",
            trigger: "change"
          }
        ],
        spell_name: [
          { required: true, message: "活动名称不能为空", trigger: "blur" }
        ],
        start_time: [
          {
            required: true,
            message: "生效时间不能为空",
            trigger: "chnage",
            validator: startTimeValidator
          }
        ],
        user_num: [
          {
            required: true,
            type: "number",
            message: "参团人数不能为空",
            trigger: "change"
          }
        ],
        group_validtime: [
          {
            required: true,
            type: "number",
            message: "拼团有效期不能为空",
            trigger: "change"
          }
        ],
        stock: [
          {
            required: true,
            type: "number",
            message: "活动库存不能为空",
            trigger: "change"
          }
        ],
        spell_price: [
          {
            required: true,
            trigger: "chnage",
            validator: priceValidator
          }
        ]
      },
      showSelectShopModal: false,
      selectItem: null,
      selectItems: [],
      status: "",
      loading: false
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    async getData() {
      if (!this.id) {
        return;
      }
      let data = await this.$http.get("/api/spellGroup/index/" + this.id);
      autoMapper(data, this.groupInfo, function(key) {
        if (key == "start_time") {
          return new Date(data.start_time * 1000);
        } else if (key == "end_time") {
          return new Date(data.end_time * 1000);
        } else if (key == "group_validtime") {
          return data.group_validtime / 3600;
        } else if (key == "is_show_group") {
          return data.is_show_group == 1;
        } else if (key == "is_auto_succ") {
          return data.is_auto_succ == 1;
        } else if (key == "is_open_check_num") {
          return data.is_open_check_num == 1;
        } else if (key == "is_check_validtime") {
          return data.is_check_validtime == 1;
        } else if (key == "is_use_coupon") {
          return data.is_use_coupon == 1;
        } else if (key == "is_head_discount") {
          return data.head_price > 0;
        } else if (key == "head_price") {
          return data.head_price / 100;
        } else if (key == "spell_price") {
          return data.spell_price / 100;
        }
        return data[key];
      });
      let selectItem = {};
      if (this.groupInfo.type == 1) {
        selectItem.type = "course";
      } else if (this.groupInfo.type == 2) {
        selectItem.type = "book";
      }
      selectItem.type_name = ShopType.getValue(data.product_type);
      selectItem.id = data.type_id;
      selectItem.name = data.name;
      selectItem.price = data.price;
      this.selectItem = selectItem;
      this.selectItems = [this.selectItem];
      this.status = data.status;
    },
    confirmSelectShop() {
      let selectItems = this.$refs.shopSelect.getSelectItems();
      if (selectItems.length == 0) {
        this.$Message.info("请选择商品");
        return;
      }
      this.selectItem = selectItems[0];
      if (this.selectItem.type == "book") {
        this.groupInfo.type = 2;
        this.groupInfo.product_type = 12;
      } else if (this.selectItem.type == "course") {
        this.groupInfo.type = 1;
        this.groupInfo.product_type = this.selectItem.course_type;
      }
      this.groupInfo.type_id = this.selectItem.id;
      this.showSelectShopModal = false;
    },
    goToShopEdit() {
      let data;
      if (this.selectItem.type == "course") {
        data = this.$router.resolve({
          name: "CourseEdit",
          query: { id: this.selectItem.id }
        });
      } else if (this.selectItem.type == "book") {
        data = this.$router.resolve({
          name: "BookEdit",
          query: { id: this.selectItem.id }
        });
      }
      window.open(data.href);
    },
    submitForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        let data = { ...this.groupInfo };
        if (this.id) {
          data.spell_id = this.id;
        }
        data.start_time = data.start_time.getTime() / 1000;
        data.end_time = data.end_time.getTime() / 1000;
        data.group_validtime = data.group_validtime * 3600;
        data.is_show_group = data.is_show_group ? 1 : 2;
        data.is_auto_succ = data.is_auto_succ ? 1 : 2;
        data.is_open_check_num = data.is_open_check_num ? 1 : 2;
        data.is_check_validtime = data.is_check_validtime ? 1 : 2;
        data.is_use_coupon = data.is_use_coupon ? 1 : 2;
        if (data.stock == "") {
          data.stock = 0;
        }
        if (!this.groupInfo.is_head_discount) {
          data.head_price = 0;
        }
        data.head_price = data.head_price * 100;
        data.spell_price = data.spell_price * 100;
        delete data.is_head_discount;
        this.loading = true;
        let config = {
          onComplete: () => {
            this.loading = false;
          }
        };
        if (this.id) {
          await this.$http.put(
            "/api/spellGroup/update/" + this.id,
            data,
            config
          );
        } else {
          await this.$http.post("/api/spellGroup/add", data, config);
        }
        this.$router.push({ name: "GroupBookingManage" });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.price {
  /deep/ {
    .ivu-input-prefix {
      line-height: 32px;
    }
  }
}
.table-price {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
  th {
    background-color: #f8f8f9;
    text-align: left;
    padding-left: 10px;
    border: 1px solid #ddd;
  }
  td {
    padding: 15px 10px;
    border: 1px solid #ddd;
  }
}
.shop-edit {
  white-space: nowrap;
  margin-left: 8px;
  cursor: pointer;
}
</style>
